export default __webpack_public_path__ + "static/media/Americana@2x.8e51e49d.png";